import React from 'react';

// Uma casa da grade. React.memo com PROPS PRIMITIVAS APENAS — é o que faz um grid
// 15×15 (225 casas) re-renderizar só a célula que mudou (§8.1). NUNCA receber
// objeto/array/lambda inline: `onClick` é uma referência ESTÁVEL do Canvas e a célula
// o chama com o próprio x,y.

export interface CellProps {
  x: number;
  y: number;
  kind: 'dead' | 'letter' | 'empty';
  letter: string;
  number: number | null;
  clue: string;
  isFocused: boolean;
  isSelected: boolean;
  conflict: boolean;
  size: number;
  onClick: (x: number, y: number) => void;
}

function background(kind: CellProps['kind'], conflict: boolean): string {
  if (conflict) return '#fff1f0';
  if (kind === 'dead') return '#2b2b2b';
  if (kind === 'empty') return '#f0f0f0';
  return '#ffffff';
}

const CellComponent: React.FC<CellProps> = ({
  x,
  y,
  kind,
  letter,
  number,
  clue,
  isFocused,
  isSelected,
  conflict,
  size,
  onClick,
}) => {
  const border = isSelected
    ? '2px solid #1677ff'
    : isFocused
    ? '2px solid #52c41a'
    : conflict
    ? '2px solid #ff4d4f'
    : '1px solid #d9d9d9';

  return (
    <div
      role="gridcell"
      aria-label={`x${x} y${y}`}
      onClick={() => onClick(x, y)}
      style={{
        position: 'relative',
        boxSizing: 'border-box',
        width: size,
        height: size,
        border,
        background: background(kind, conflict),
        color: kind === 'dead' ? '#fff' : '#000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        cursor: 'pointer',
        overflow: 'hidden',
        userSelect: 'none',
      }}
    >
      {number != null && (
        <span style={{ position: 'absolute', top: 1, left: 2, fontSize: Math.max(8, size * 0.22), lineHeight: 1 }}>
          {number}
        </span>
      )}
      {kind === 'dead' ? (
        <span style={{ fontSize: Math.max(6, size * 0.16), lineHeight: 1.05, textAlign: 'center', padding: 1 }}>
          {clue}
        </span>
      ) : (
        <span style={{ fontSize: size * 0.5, fontWeight: 600 }}>{letter}</span>
      )}
    </div>
  );
};

export const Cell = React.memo(CellComponent);
